import isObject from './isObject';

/**
 * Recursively merges two objects, where properties from `obj2` overwrite properties in `obj1`
 * if they have the same key.
 *
 * @param {Object} obj1 - The first object to merge.
 * @param {Object} obj2 - The second object whose properties will be merged into `obj1`.
 * @returns {Object} - The merged object.
 */
const mergeObjects = (obj1, obj2) => {
	const merged = { ...obj1 };

	// Iterate over keys in obj2
	Object.keys(obj2).forEach((key) => {
		// If obj2's key is an object and also exists in obj1, recursively merge them
		if (isObject(obj2[key]) && isObject(obj1?.[key])) {
			merged[key] = mergeObjects(obj1[key], obj2[key]);
		} else {
			// Otherwise, assign obj2's value to the merged object
			merged[key] = obj2[key];
		}
	});

	return merged;
};

export default mergeObjects;
